module.exports = __webpack_public_path__ + "static/media/redux.5c7392a9.svg";